import React from "react";

interface LoadingProps {
  fullScreen?: boolean;
  size?: "sm" | "md" | "lg";
  showText?: boolean;
}

const Loading: React.FC<LoadingProps> = ({ 
  fullScreen = true, 
  size = "md",
  showText = true 
}) => {
  const sizeClasses = {
    sm: "w-8 h-8",
    md: "w-16 h-16",
    lg: "w-24 h-24",
  };

  const textSizeClasses = {
    sm: "text-sm",
    md: "text-lg",
    lg: "text-xl",
  };

  const containerClasses = fullScreen
    ? "hero-surface fixed inset-0 h-screen w-screen flex items-center justify-center bg-gradient-to-br from-mango-50 via-farm-50 to-golden-50 relative overflow-hidden z-50"
    : "flex items-center justify-center py-12 min-h-[400px]";

  return (
    <div className={containerClasses}>
      {/* Background Pattern - only for full screen */}
      {fullScreen && (
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg%20width%3D%2260%22%20height%3D%2260%22%20viewBox%3D%220%200%2060%2060%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%3Cg%20fill%3D%22%23fbbf24%22%20fill-opacity%3D%220.1%22%3E%3Ccircle%20cx%3D%2230%22%20cy%3D%2230%22%20r%3D%224%22/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')]"></div>
        </div>
      )}

      <div className="text-center relative z-10">
        {/* Animated crescent arc with gradient - professional dual spinner */}
        <div className={`relative ${sizeClasses[size]} mx-auto ${showText ? "mb-6" : ""}`}>
          <div aria-hidden="true" className="pointer-events-none absolute inset-0 rounded-full border-4 border-mango-100/80"></div>
          {/* Outer rotating arc */}
          <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-mango-500 border-r-golden-500 animate-spin" style={{ animationDuration: "1s" }}></div>
          {/* Inner counter-rotating arc */}
          <div
            className="absolute inset-2 rounded-full border-4 border-transparent border-t-golden-400 border-r-mango-400 animate-spin"
            style={{ animationDirection: "reverse", animationDuration: "1.5s" }}
          ></div>
        </div>
        {showText && (
          <p
            className={`text-gray-700 font-medium tracking-wide ${textSizeClasses[size]} transition-opacity`}
            style={{ fontFamily: "Inter, system-ui, sans-serif" }}
          >
            Loading...
          </p>
        )}
      </div>
    </div>
  );
};

export default Loading;

